export const catalogCenterJa = {
  businessCategory: "業務入口",
  platformEntryCategory: "プラットフォーム入口",
  platformCenterCategory: "プラットフォームセンター",
  platformCapabilityCategory: "プラットフォーム能力",
  platformInfrastructureCategory: "プラットフォーム基盤",
  examAdminName: "試験業務管理",
  examAdminNote: "問題・試験用紙・試験・採点・考務運営を扱います。",
  candidateName: "受験側アプリ",
  candidateNote: "試験入口、回答、提出、結果確認を扱います。",
  microLabName: "マイクロ実験",
  microLabNote: "マイクロ実験広場と実験実行の入口で、統合認証・アセットセンター・実行基盤へ直接接続します。",
  eduAdminName: "教育管理",
  eduAdminNote: "コース、教学計画、研修プロジェクト、メンバー、公開講座運営の入口です。",
  eduName: "学習ポータル",
  eduNote: "公開講座学習、指派学習、研修プロジェクト、学習者入口です。",
  aitestName: "テスト靶場",
  aitestNote: "統合認証・アセットセンター・実行基盤に直接接続する最小接入検証アプリです。",
  redblueAdminName: "RedBlue 管理",
  redblueAdminNote: "RedBlue 演習のスキーム、活動、ディレクター画面、ジャッジ画面、状況レビューを管理します。",
  redblueName: "RedBlue ポータル",
  redblueNote: "RedBlue 演習の参加、ワークベンチ、観測、レポート入口です。",
  portalName: "AIRange ポータル",
  portalNote: "統一ポータル、アプリ導線、主入口です。",
  resourceSpace: "リソース空間",
  resourceSpaceNote: "個人・共有リソース空間に入り、アップロードファイル、ブランド資産、共有素材を管理します。",
  accountCenter: "アカウントセンター",
  accountCenterNote: "統合認証ユーザーのアカウント情報と個人設定の入口です。",
  platformAdminName: "プラットフォーム管理",
  platformAdminNote: "プラットフォーム制御面の管理画面で、試験業務画面は含みません。",
  ssoName: "統合認証センター",
  ssoNote: "統一ログイン、セッション、アプリ接入、認証方針を扱います。",
  assetsName: "アセットセンター",
  assetsNote: "オブジェクト保存、メタデータ、認可制御を扱います。",
  environmentNote: "環境仕様、イメージ、テンプレート、トポロジ資産を一元管理します。",
  executionName: "実行基盤",
  executionNote: "コンテナ実行時、インスタンス編成、実行制御面を扱います。",
  taskCenterName: "タスクセンター",
  taskCenterNote: "タスク状態口径、イベント観測、失敗コード統治を扱います。",
  instanceCenterNote: "インスタンス実行状態、リモート接続、インスタンス単位の操作記録を一元表示します。",
  orchestratorCenterNote: "環境オーケストレーション要求、回収フロー、オーケストレーション操作を一元表示します。",
  intelligenceCenterNote: "モデル接続、プロバイダー設定、タスク実行、監査ログを一元管理します。",
  capabilityGraphNote: "能力グラフ、KSA 分類、能力間の関係を一元表示します。",
  tacticsTechniquesHubNote: "戦術・技法フレームワーク、マトリクス対応、バインディング演習を一元表示します。",
  vulnerabilityLibraryNote: "CVE、CNVD など公式脆弱性番号と内部統一脆弱性レコードを管理します。",
  businessReferenceCenterNote: "業務横断のリソース参照、逆引き関係、変更前保護チェックを登録します。",
  trafficLibraryNote: "パケットファイル、1 階層カテゴリ、アセットセンターのファイル参照を登録します。",
  toolsLibraryNote: "システム内ツールファイル、1 階層カテゴリ、ダウンロード入口を管理します。",
  examApiName: "Exam API",
  examApiNote: "試験業務専用の公開 API で、現在の公開入口はサービス入口レジストリから解決されます。",
  registryNote: "プラットフォームレジストリの接続状況と可用性を一元表示します。",
} as const;
